import axios from "../../helpers/axios"
import { deliveryInfoConstants } from "../constants"


export const getDeliveryInfo = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: deliveryInfoConstants.GET_DELIVERY_INFO_REQUEST })
            const res = await axios.get("deliveryInfo/get")
            if (res.status === 200) {
                const { deliveryInfo } = res.data
                dispatch({
                    type: deliveryInfoConstants.GET_DELIVERY_INFO_SUCCESS,
                    payload: {
                        deliveryInfo
                    }
                })
            } else {
                dispatch({ type: deliveryInfoConstants.GET_DELIVERY_INFO_FAILURE })
            }
        } catch (e) {
            console.log(e)
        }
    }
}